var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from '@mui/material/styles';
import Select from './Select';
import FormControl, { useFormControl, FormHelperText } from '../FormControl';
import InputLabel from '../InputLabel';
// TODO: Add in width as a prop for select (auto being default)
// TODO: Add styling on drop down (right most icon)
// TODO: Add size small
// Styled FormControl component
const StyledFormControl = styled(FormControl)({
    padding: 0,
    alignContent: 'center'
});
// Styled InputLabel component
const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
    '&.MuiInputLabel-root': {
        transform: 'translate(10px, 8px)',
        color: theme.palette.textField.label.text.default,
        '&.Mui-error': { color: theme.palette.textField.label.text.error },
        '&.Mui-disabled': { opacity: 1, color: theme.palette.textField.label.text.disabled }
    },
    '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -7px) scale(0.75)',
        color: theme.palette.textField.label.text.default,
        '&.Mui-error': { color: theme.palette.textField.label.text.error },
        '&.Mui-disabled': { opacity: 1, color: theme.palette.textField.label.text.disabled }
    }
}));
// Styled FormHelperText component
const CustomFormHelperText = styled(FormHelperText)(({ theme }) => ({
    fontFamily: theme.palette.textField.helpText.font.family,
    fontSize: theme.palette.textField.helpText.font.size,
    fontWeight: theme.palette.textField.helpText.font.weight,
    lineHeight: theme.palette.textField.helpText.font.lineHeight,
    letterSpacing: theme.palette.textField.helpText.font.letterSpacing,
    marginLeft: theme.palette.textField.padding,
    color: theme.palette.textField.helpText.text.default,
    '&.Mui-error': { color: theme.palette.textField.helpText.text.error },
    '&.Mui-disabled': { opacity: 1, color: theme.palette.textField.helpText.text.disabled },
    '&.MuiInputAdornment-root': {
        marginRight: 0
    }
}));
const BDSSelectWrapper = (_a) => {
    var _b;
    var { bdsContainerType = 'container', error, disabled: propDisabled, label, helperText, startIcon, fullWidth } = _a, rest = __rest(_a, ["bdsContainerType", "error", "disabled", "label", "helperText", "startIcon", "fullWidth"]);
    const disabled = ((_b = useFormControl()) === null || _b === void 0 ? void 0 : _b.disabled) || propDisabled;
    return (React.createElement(StyledFormControl, { error: error, disabled: disabled, fullWidth: fullWidth },
        bdsContainerType === 'container' && label && React.createElement(StyledInputLabel, null, label),
        React.createElement(Select, Object.assign({ bdsContainerType: bdsContainerType, error: error, disabled: disabled, startIcon: startIcon, label: label }, rest)),
        bdsContainerType === 'container' && helperText && React.createElement(CustomFormHelperText, null, helperText)));
};
BDSSelectWrapper.displayName = 'SelectWrapper';
export default BDSSelectWrapper;
//# sourceMappingURL=SelectWrapper.js.map